import { Outlet } from "react-router-dom";
import { usePlatform } from "..//PlatformContext";
import { OnboardingContainer } from "../features/onboarding/components/Onboarding/OnboardingContainer";
import { OnboardingHeaderContainer } from "../features/onboarding/components/OnboardingHeader/OnboardingHeaderContainer";
import { AppLayout } from "./AppLayout";

export type Props = {
  title: string;
};

export const OnboardingLayout = ({ title }: Props) => {
  const { invitation, organization, program } = usePlatform();

  return (
    <AppLayout
      header={<OnboardingHeaderContainer />}
      className="flex-grow flex flex-col h-full w-full mx-auto md:flex-row"
      isWithFooter={false}
      title={title}
    >
      <OnboardingContainer
        invitation={invitation}
        organization={organization}
        program={program}
      >
        <Outlet />
      </OnboardingContainer>
    </AppLayout>
  );
};

export default OnboardingLayout;
